var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pj_content"},[_c('Header'),_c('KindList'),_c('Mian'),_c('LotteryType'),_c('Footer'),_c('Bottom',{attrs:{"bottomImg":_vm.$store.getters.getUrl('pj01_footer_fixed')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }